
import { ref, reactive, watch, inject } from 'vue'
import { useRoute } from 'vue-router'
export default {
  props: {
    isScroll: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const route = useRoute()
    let menuData = reactive({
      isChange: route.fullPath === '/',
      activeIndex: (route.fullPath === '/businessContent' || route.fullPath === '/about') ? route.fullPath + '?id=0' : route.fullPath,
      textColor: route.fullPath === '/' ? '#FFFFFF': '#374567',
      activeColor: route.fullPath === '/' ? '#FFFFFF': '#446AE7'
    })

    watch(() => route.path, (params) => {
      menuData.activeIndex = params
      handleSelect(params)
    })

    const handleMenuActive = inject('handleMenuActive')
    const handleSelect = (params) => {
      handleMenuActive(params)
      if (params === '/') {
        menuData.isChange = true
        menuData.textColor = '#FFFFFF'
        menuData.activeColor = '#FFFFFF'
      } else {
        menuData.isChange = false
        menuData.textColor = '#374567'
        menuData.activeColor = '#446AE7'
      }
      if (!params.includes('about') || params === '/about?id=0') {
        context.emit('initScroll')
      }
    }

    const handleTwo = () => {
      if (route.query['id']){
        menuData.activeIndex = route.fullPath
      } else if (['/businessContent', '/about'].includes(route.path)) {
        menuData.activeIndex = route.path+ '?id=0'
      } else {
        menuData.activeIndex = route.fullPath
      }
    }

    const loginShow = ref(false)
    const changeLoginShow = () => {
      loginShow.value = !loginShow.value
    }

    return {
      menuData,
      handleSelect,
      handleTwo,
      loginShow,
      changeLoginShow
    }
  }
}
